module.exports = __webpack_public_path__ + "static/images/intro1_feabd4a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro1.png
// module id = 229
// module chunks = 1